import { StepsEnum } from '../../types';
import { CheckinStep } from '../../Modules/Checkin/types';
import { CdnIconNames } from '@shared/ui';

export const STEP_ICON_NAME_BY_TYPE: Record<string, CdnIconNames> = {
	[StepsEnum.Flights]: 'Flight/Direction',
	[StepsEnum.Seats]: 'Services/Seat Selection',
	[StepsEnum.Baggage]: 'Baggage/Checked-in',
	[StepsEnum.Restrictions]: 'Info/Not included',
	[StepsEnum.Meal]: 'Services/Meal',
	[StepsEnum.Passengers]: 'Info/Passenger',
	[StepsEnum.Order]: 'Info/Show',
	[StepsEnum.Insurance]: 'Services/Insurance',
	[StepsEnum.Payment]: 'Info/Item Paid',
	[StepsEnum.Extras]: 'Amenity/Seat_Recline_Extra',
	[StepsEnum.BoardingPass]: 'Document/Boarding pass',
	[StepsEnum.Upgrade]: 'Document/Ticket',
	[CheckinStep.Passengers]: 'Info/Passenger',
	[CheckinStep.Seats]: 'Services/Seat Selection',
	[CheckinStep.Baggage]: 'Baggage/Checked-in',
	[CheckinStep.Meal]: 'Services/Meal',
	[CheckinStep.Extras]: 'Services/Insurance',
	[CheckinStep.Upgrade]: 'Document/Ticket',
	[CheckinStep.Payment]: 'Info/Item Paid',
	flights: 'Flight/Direction'
};
